import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { TOfferingsIconSizes } from 'partner360/components/offeringWithIcon'

/* Every offering asset pads its drawing differently inside the canvas, so one box size leaves the
   marks visibly unequal. Each size is set so the drawing itself spans about 17px, matching the
   Overall glyph; the tab strip centres them in a fixed 20px slot. */
export const PROGRAM_TYPE_TAB_ICON_SIZES: TOfferingsIconSizes = {
  [ProgramTypes.CorePrint]: { width: 22, height: 22 },
  [ProgramTypes.Print]: { width: 22, height: 22 },
  [ProgramTypes.PersonalSystems]: { width: 20, height: 20 },
  [ProgramTypes.PC]: { width: 20, height: 20 },
  [ProgramTypes.LargeFormat]: { width: 20, height: 20 },
  [ProgramTypes.LF]: { width: 20, height: 20 },
  [ProgramTypes.Printing3D]: { width: 17, height: 17 },
  [ProgramTypes.Supplies]: { width: 17, height: 17 },
}
